import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0.5rem;
  background-color: var(--color-warning);
  ${({ info }) =>
    info &&
    css`
      background-color: var(--color-info);
    `};
`;
